import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'

import { ListProps } from './types'

const ListItemWrapper = styled.div`
  display: flex;

  :not(:last-child) {
    margin-bottom: 40px;
  }
`

const ListWrapper = styled.div``

const IconWrapper = styled.div<{ backgroundColor?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  background: ${props => props.backgroundColor ?? colors.blue96};
  border-radius: 6px;
  margin-right: 20px;

  > svg {
    width: 24px;
    height: 24px;
  }
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 438px;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    max-width: unset;
  }
`

const ItemHeading = styled.p`
  font-family: Inter, sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey08};
  margin: 0 0 8px 0;
`

const ItemContent = styled.p`
  font-family: Inter, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.grey16};
  margin: 0;
`

const IconList: React.FC<ListProps> = ({ listItems, backgroundColor }) => {
  return (
    <ListWrapper>
      {listItems.map(({ title, content, icon: IconComponent }, index) => {
        return (
          <ListItemWrapper key={`list-item-${index}`}>
            <IconWrapper backgroundColor={backgroundColor}>
              <IconComponent />
            </IconWrapper>
            <TextWrapper>
              <ItemHeading>{title}</ItemHeading>
              <ItemContent>{content}</ItemContent>
            </TextWrapper>
          </ListItemWrapper>
        )
      })}
    </ListWrapper>
  )
}

export default IconList
